import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FirebaseService } from '../services/firebase.service';
import { Logger } from 'src/app/services/datadog.logger.service';


@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  constructor (
    private firebaseService:FirebaseService,
    private router:Router,
    private logger:Logger
    ) {}

  // Returns whether or not the user has passed the AuthGuard, if true that means the user can access the guarded page
  // test
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      this.logger.info(`Entering method canActivate.
      Parameters: next=${next}, state=${state}`)
  

      let user = await this.firebaseService.isLoggedIn()
      
      if (user) {
        this.logger.info('Exiting method canActivate')
        return true
      }
      
      // If the user is not logged in then take the user to the login screen and set the return url so that we know which url to show after the user has logged in
      this.router.navigate(['login'], { queryParams: { returnUrl: state.url } })
      this.logger.info('Exiting method canActivate')

      return false;
    }
}
